// extracted by mini-css-extract-plugin
var _1 = "ProductUpdateCard-module__animateUploadProgressBarWidth--cDi6j";
var _2 = "ProductUpdateCard-module__animatedBackground--HfEbR";
var _3 = "ProductUpdateCard-module__badge--LYOS5";
var _4 = "ProductUpdateCard-module__banner--D5643";
var _5 = "ProductUpdateCard-module__card--jI6tc";
var _6 = "ProductUpdateCard-module__title--dFitB";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "badge", _4 as "banner", _5 as "card", _6 as "title" }
